import { render } from "./AccountHeader.vue?vue&type=template&id=b5af9fa4&scoped=true"
import script from "./AccountHeader.vue?vue&type=script&lang=js"
export * from "./AccountHeader.vue?vue&type=script&lang=js"

import "./AccountHeader.vue?vue&type=style&index=0&id=b5af9fa4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5af9fa4"]])

export default __exports__